import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { toast } from "react-toastify";
import TextInput from "../../TextInput";
import PropTypes from "prop-types";

const AuthKeyModal = ({ clientId, open, onClose, getWMSAuthKey, saveWMSAuthKey }) => {
  const [authKey, setAuthKey] = useState("");

  const onSave = async () => {
    try {
      await saveWMSAuthKey(clientId, authKey);
      toast.success("Auth key saved");
      onClose();
    } catch (error) {
      toast.error("Unable to save auth key");
    }
  }

  const fetchKey = async () => {
    try {
      const key = await getWMSAuthKey(clientId);
      setAuthKey(key);
    } catch (error) {
      console.error("AuthKeyModal: fetchKey: error: ", error);
    }
  }

  useEffect(() => {
    // Fetch Auth Key
    if (open) {
      fetchKey();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Modal zIndex={2000} size={"md"} centered isOpen={open} toggle={onClose}>
      <ModalHeader toggle={onClose}>WMS Auth Key</ModalHeader>
      <ModalBody>
        <TextInput
          label="Auth Key"
          value={authKey}
          onChange={(e) => setAuthKey(e.target.value)}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={onSave}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AuthKeyModal;

AuthKeyModal.propTypes = {
  open: PropTypes.bool,
  clientId: PropTypes.string,
  onClose: PropTypes.func,
  getWMSAuthKey: PropTypes.func,
  saveWMSAuthKey: PropTypes.func
};
